import script from "./FlagsQuizPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FlagsQuizPage.vue?vue&type=script&setup=true&lang=js"

import "./FlagsQuizPage.vue?vue&type=style&index=0&id=1e9e16e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9e16e7"]])

export default __exports__